import Tab, { type TabProps } from "@mui/material/Tab";
import MuiTabs, { type TabsProps } from "@mui/material/Tabs";
import Box from "ui/atom/Box";


type TPanelProps = {
	children?: React.ReactNode;
	value: unknown;
	selected: unknown;
};

Tabs.Panel = (props: TPanelProps) => {
	const { children, value, selected, ...other } = props;

	const style = {
		root: { mt: 3 }
	} as SxProps;

	return value === selected && (
		<Box.Column gap={2}
			role="tabpanel"
			hidden={value !== selected}
			sx={style.root}
			{...other}
		>
			{children}
		</Box.Column>
	);
};

Tabs.Tab = (props: TabProps) => <Tab {...props} />;

export default function Tabs(props: TabsProps) {
	const style = {
		root: {
			mb: 3,
			...props.sx
		}
	} as SxProps;
	return <MuiTabs {...props} sx={style.root} />;
}